import { useContext } from 'react';
import StakingContext from '../contexts/StakingContext';

const useStaking = () => useContext(StakingContext);

export default useStaking;
